import {Component, Inject, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthFacadeService} from "@emm/auth/services/auth-facade.service";

@Component({
    selector: 'emm-remove-item-dialog',
    templateUrl: './remove-item-dialog.component.html',
    styleUrls: ['./remove-item-dialog.component.scss'],
    standalone: false
})
export class RemoveItemDialogComponent implements OnInit{
    displayDeleteGlobal = false;
    isReadOnly$ = this.authFacade.isReadOnly$;
    itemTag: string;
    parentTag: string;

    constructor(
        public dialogRef: MatDialogRef<RemoveItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public authFacade: AuthFacadeService
    ) {
        this.itemTag = data.tag;
        this.parentTag = data.parentTag;
    }


    ngOnInit(): void {
    }


    cancelRemoveItem(): void {
        this.dialogRef.close();
    }


    removeItem(): void {
        this.dialogRef.close(true);
    }

}
